/** User-facing copy for working away from home (shift summary → job costing → rate card). */

/**
 * Typography `sx` for text inside MUI `Tooltip` titles. Default `Typography` colours use the
 * theme text/primary palette and stay dark on the tooltip surface (poor contrast).
 */
export const WORKING_AWAY_TOOLTIP_TYPOGRAPHY_SX = {
  color: 'rgba(255, 255, 255, 0.97)',
  lineHeight: 1.45,
} as const;

export const WORKING_AWAY_INFO_ARIA_LABEL =
  'How working away from home affects job costing';

export const SHIFT_SUMMARY_FLAG_TOOLTIP =
  'When this inspection is marked as working away from home, it counts toward away-from-home nights on the job. Job costing multiplies those nights by the technician’s working away from home labour cost and billing rates (from the rate card) and adds the result to labour cost and billing.';

export const SHIFT_SUMMARY_FLAG_CAPTION =
  'Included when the job calculates away-from-home nights for labour costing and billing.';

export const JOB_COSTING_AWAY_TOOLTIP =
  'Away-from-home cost and billing are nights counted for the job multiplied by each technician’s working away from home labour cost and billing rates. Both are added to labour totals.';

export const JOB_COSTING_AWAY_ROW_TOOLTIP =
  'Total cost and billing are nights × the nightly cost and billing rates. Period breakdown is listed below.';

export const RATE_CARD_WORKING_AWAY_COST_HEADER_TOOLTIP =
  'Cost per night away from home. Job costing uses this rate when calculating away-from-home labour cost for a job.';

export const RATE_CARD_WORKING_AWAY_BILLING_HEADER_TOOLTIP =
  'Billing per night away from home. Job costing uses this rate when calculating away-from-home labour billing for a job. Supports default, client, and branch combinations.';

/** @deprecated Use RATE_CARD_WORKING_AWAY_COST_HEADER_TOOLTIP */
export const RATE_CARD_WORKING_AWAY_HEADER_TOOLTIP =
  RATE_CARD_WORKING_AWAY_COST_HEADER_TOOLTIP;

export const BREAK_TAKEN_TEXT =
  'A 30-minute break was detected during this visit.';

export const BREAK_TAKEN_TOOLTIP =
  'A 30-minute break was detected during this shift. It has been deducted from the total on site hours for this shift, which may affect labour costing for the job.';
